export const FAQ = [
  {
    q: "¿Cuánto tiempo tarda en verse resultados?",
    a: "Con disciplina total al plan, los primeros cambios se notan entre la 2da y 4ta semana. Cambios visibles importantes entre 8-12 semanas. La constancia es la clave.",
  },
  {
    q: "¿Necesito suplementos para progresar?",
    a: "No son obligatorios. Lo principal es alimentación + entrenamiento + descanso. Suplementos como whey, creatina y multivitamínico ayudan pero no son indispensables al inicio.",
  },
  {
    q: "¿Puedo entrenar en casa sin equipo?",
    a: "Sí. Tenemos rutinas específicas con peso corporal y con bandas elásticas que son igual de efectivas para principiantes e intermedios.",
  },
  {
    q: "¿Qué pasa si me salto una comida?",
    a: "No pasa nada puntualmente. Lo importante es no convertirlo en hábito. Mantén tus macros del día compensando con otras comidas si lo necesitas.",
  },
  {
    q: "¿Cómo mido mi progreso correctamente?",
    a: "Peso mismo día y hora 1x semana. Medidas corporales cada 15 días. Fotos en mismas condiciones cada 15 días. La balanza no lo es todo: usa también espejo y ropa.",
  },
  {
    q: "¿Puedo hacer cardio extra para perder grasa más rápido?",
    a: "Sí, 2-4 sesiones de cardio moderado o HIIT por semana ayudan en déficit. No abuses: el déficit principal viene de la alimentación.",
  },
  {
    q: "¿Cuál es la diferencia entre los planes AS START, EVOLUTION y ELITE?",
    a: "AS START: rutina + nutrición básica. AS EVOLUTION: plan personalizado + seguimiento quincenal. AS ELITE: plan 100% individual + soporte 24/7 + ajustes ilimitados + consulta de fotos.",
  },
];

export const LIBRARY_RESOURCES = [
  {
    id: "exercises",
    title: "Guía de Ejercicios",
    description: "Catálogo de ejercicios fundamentales con técnica correcta.",
    icon: "Barbell",
    type: "pdf",
  },
  {
    id: "nutrition-guide",
    title: "Guía de Alimentación",
    description: "Principios de nutrición deportiva y planeación de comidas.",
    icon: "ForkKnife",
    type: "pdf",
  },
  {
    id: "supplementation",
    title: "Guía de Suplementación",
    description: "Qué tomar, cuándo y por qué. Suplementos seguros y efectivos.",
    icon: "Pill",
    type: "pdf",
  },
  {
    id: "videos",
    title: "Videos Demostrativos",
    description: "Técnica de ejercicios clave en video.",
    icon: "Video",
    type: "video",
  },
];
